import {Taxonomy} from './taxonomy';
import railsData from 'utilities/rails-data';

type Path = string;

const Domain: string = `https://${railsData('services_marketplace.host')}`;

const Routes = {
  homePath: (): Path => {
    return '/';
  },

  preCommerceLeadSubmitPath: '/pre-commerce-lead',

  postJobLoginPath: ({
    shop,
    serviceHandle,
    expertHandle,
  }: {
    shop: string;
    serviceHandle?: string;
    expertHandle?: string;
  }): Path => {
    const formattedShop = formatShop(shop);
    return `/create-a-job?shop=${formattedShop}&context=${serviceHandle}&expert=${expertHandle}`;
  },

  loginPath: (
    shop: string,
    redirectLocation: string = window.location.pathname
  ): Path => {
    const formattedShop = formatShop(shop);
    return `/auth/login?shop=${formattedShop}&redirect_to=${encodeURIComponent(
      redirectLocation
    )}`;
  },

  logoutPath: '/auth/logout',

  jobsPath: (shop: string): Path => {
    const formattedShop = formatShop(shop);
    return `/services_marketplace/job_requests?shop=${formattedShop}`;
  },

  jobPath: (shop: string, id: string): Path => {
    const formattedShop = formatShop(shop);
    return `/services_marketplace/job_requests/${id}?shop=${formattedShop}`;
  },

  invoicesPath: (shop: string): Path => {
    const formattedShop = formatShop(shop);
    return `/services_marketplace/invoices?shop=${formattedShop}`;
  },

  workflowPath: (shop: string): Path => {
    const formattedShop = formatShop(shop);
    return `/services_marketplace?shop=${formattedShop}`;
  },

  profilePath: (expertHandle: string): Path => {
    return `/${expertHandle}`;
  },

  profileLink: (expertHandle: string): string => {
    return `${Domain}/${expertHandle}`;
  },

  profileServiceListingPath: (
    expertHandle: string,
    serviceHandle: string
  ): Path => {
    return `/${expertHandle}/${toSlug(serviceHandle)}`;
  },

  servicePath: (taxonomy: Taxonomy, serviceHandle: string): Path => {
    const ancestors = taxonomy.getAncestors(serviceHandle);
    const handles = ancestors
      .map(service => service.handle)
      .concat([serviceHandle])
      .map(toSlug);

    return `/services/${handles.join('/')}`;
  },

  imagePath: (location: string): Path => {
    return `/images/services_marketplace/${location}`;
  },

  referralUrl: (source: string): Path => {
    return `${railsData(
      'app_config.brochure_url'
    )}?utm_campaign=services-marketplace&utm_source=${source}`;
  },

  supportUrl: (): Path => {
    return 'https://help.shopify.com/en/questions#/questions';
  },

  helpUrl: (): Path => {
    return 'https://help.shopify.com/';
  },

  termsOfServiceUrl: (): Path => {
    return `${railsData('app_config.brochure_url')}legal/terms`;
  },

  privacyPolicyUrl: (): Path => {
    return `${railsData('app_config.brochure_url')}legal/privacy`;
  },
};

function toSlug(word: string) {
  return word.replace(/_/g, '-');
}

function toHandle(word: string) {
  return word.replace(/-/g, '_');
}

function formatShop(shop: string) {
  const myshopifyDomain = `.${railsData('shopify_app.myshopify_domain')}`;
  const formattedShop = shop
    .replace(myshopifyDomain, '')
    .replace('https://', '')
    .replace('http://', '')
    .replace(/[^\w|-]/g, '');

  return formattedShop.concat(myshopifyDomain);
}

export {Routes, toSlug, toHandle, formatShop};
